'use client';
import { __rest, __assign } from '../_virtual/_tslib.js';
import { Root as $cc7e05a45900e73f$export$be92b6f5f03c0fe9, Trigger as $cc7e05a45900e73f$export$41fb9f06171c75f4, Value as $cc7e05a45900e73f$export$4c8d1a57a761ef94, Portal as $cc7e05a45900e73f$export$602eac185826482c, Content as $cc7e05a45900e73f$export$7c6e2c02157bb7d2, Viewport as $cc7e05a45900e73f$export$d5c6c08dc2d3ca7, Item as $cc7e05a45900e73f$export$6d08773d2e66f8f2, ItemText as $cc7e05a45900e73f$export$d6e5bf9c43ea9319 } from '../packages/subframe-core/external/@radix-ui/react-select/dist/index.js';
import classNames from '../external/classnames/index.js';
import React__default from 'react';
import styles from './select.module.css.js';

var Root = React__default.forwardRef(function SelectRoot(_a, _ref) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return React__default.createElement($cc7e05a45900e73f$export$be92b6f5f03c0fe9, __assign({}, otherProps), children);
});
var Trigger = React__default.forwardRef(function Trigger(_a, ref) {
    var className = _a.className, children = _a.children; _a.placeholder; var otherProps = __rest(_a, ["className", "children", "placeholder"]);
    return (React__default.createElement($cc7e05a45900e73f$export$41fb9f06171c75f4, __assign({ className: classNames(className, styles.trigger), ref: ref }, otherProps), children));
});
var Value = React__default.forwardRef(function Value(_a, ref) {
    _a.children; // NOTE: ignored
    var placeholder = _a.placeholder, className = _a.className, otherProps = __rest(_a, ["children", "placeholder", "className"]);
    return (
    // NOTE: this needs a wrapper since Radix strips all styling from RadixSelect.Value
    React__default.createElement("span", __assign({ className: classNames(className, styles.value) }, otherProps, { ref: ref }),
        React__default.createElement($cc7e05a45900e73f$export$4c8d1a57a761ef94, { placeholder: placeholder })));
});
var Content = React__default.forwardRef(function Content(_a, ref) {
    var className = _a.className, children = _a.children, portalClassName = _a.portalClassName, _b = _a.position, position = _b === void 0 ? "popper" : _b, _c = _a.sideOffset, sideOffset = _c === void 0 ? 4 : _c, otherProps = __rest(_a, ["className", "children", "portalClassName", "position", "sideOffset"]);
    return (React__default.createElement($cc7e05a45900e73f$export$602eac185826482c, { className: portalClassName },
        React__default.createElement($cc7e05a45900e73f$export$7c6e2c02157bb7d2, __assign({ className: classNames(className, styles.content), ref: ref, position: position, sideOffset: sideOffset }, otherProps),
            React__default.createElement(Select.Viewport, { asChild: true }, children))));
});
var Viewport = React__default.forwardRef(function Viewport(_a, ref) {
    var className = _a.className, children = _a.children, otherProps = __rest(_a, ["className", "children"]);
    return (React__default.createElement($cc7e05a45900e73f$export$d5c6c08dc2d3ca7, __assign({ className: classNames(className, styles.viewport), ref: ref }, otherProps), children));
});
var Item = React__default.forwardRef(function Item(_a, ref) {
    var className = _a.className, children = _a.children, value = _a.value, otherProps = __rest(_a, ["className", "children", "value"]);
    return (React__default.createElement($cc7e05a45900e73f$export$6d08773d2e66f8f2, __assign({ className: classNames(className, styles.item), ref: ref, value: value }, otherProps), children));
});
var ItemText = $cc7e05a45900e73f$export$d6e5bf9c43ea9319;
var Select = {
    Root: Root,
    Trigger: Trigger,
    Value: Value,
    Content: Content,
    Viewport: Viewport,
    Item: Item,
    ItemText: ItemText,
};

export { Content, Item, ItemText, Root, Select, Trigger, Value, Viewport };
